import React from 'react';
import ReactDOM from 'react-dom';
import {
  init,
  browserTracingIntegration,
  replayIntegration,
} from '@sentry/react';
import TagManager from '@sooro-io/react-gtm-module';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { worker } from './test/mocks/browser';

if (process.env.REACT_APP_SENTRY_DSN) {
  init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT || 'dev',
    release: process.env.REACT_APP_VERSION,
    integrations: [browserTracingIntegration(), replayIntegration()],
    tracePropagationTargets: [
      /^https:\/\/backend\.(stage|prod|[\w-]+\.pv\.dev)\.zestmsp\.com/,
      'localhost',
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Suppress benign ResizeObserver loop warnings from CRA's dev overlay.
const resizeObserverErrSilencer = (e: ErrorEvent) => {
  if (
    e.message &&
    /ResizeObserver loop (completed|limit exceeded)/.test(e.message)
  ) {
    e.stopImmediatePropagation();
  }
};
window.addEventListener('error', resizeObserverErrSilencer);

const tagManagerArgs = {
  gtmId: 'GTM-TCSPBNT',
};
TagManager.initialize(tagManagerArgs);

function prepare() {
  if (process.env.NODE_ENV === 'development') {
    return worker.start();
  }
  return Promise.resolve();
}
prepare().then(() => {
  ReactDOM.render(<App />, document.getElementById('root'));
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
